export const featured = [
  {
    contentId: "shenhai-huisheng",
    tag: "最新上线",
    image: "https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20with%20glowing%20blue%20bioluminescence%20and%20submarine%20silhouette%2C%20epic%20cinematic%20wide%20shot%2C%20dark%20blue%20atmosphere%20with%20dramatic%20light%20rays%2C%20artistic%20sci-fi%20poster&width=1920&height=1000&seq=gydb-hero-01&orientation=landscape",
  },
  {
    contentId: "wugang-huisheng",
    tag: "口碑推荐",
    image: "https://readdy.ai/api/search-image?query=foggy%20harbor%20at%20night%20with%20warm%20lamp%20glow%20reflecting%20on%20water%2C%20cinematic%20wide%20shot%2C%20deep%20blue%20moody%20tones%20with%20soft%20mist%2C%20mysterious%20artistic%20atmosphere&width=1920&height=1000&seq=gydb-hero-02&orientation=landscape",
  },
  {
    contentId: "shanhe-shiwei",
    tag: "高分纪录片",
    image: "https://readdy.ai/api/search-image?query=rustic%20chinese%20kitchen%20with%20steaming%20dishes%20and%20warm%20firelight%2C%20cinematic%20wide%20shot%2C%20warm%20earth%20tones%20against%20soft%20blue%20shadows%2C%20documentary%20artistic%20atmosphere&width=1920&height=1000&seq=gydb-hero-03&orientation=landscape",
  },
  {
    contentId: "xinghai-shiyi",
    tag: "人气国漫",
    image: "https://readdy.ai/api/search-image?query=vast%20starry%20galaxy%20with%20colorful%20nebula%20and%20a%20lone%20starship%2C%20cinematic%20wide%20shot%2C%20vivid%20blue%20and%20warm%20orange%20cosmic%20gradient%2C%20epic%20illustration&width=1920&height=1000&seq=gydb-hero-04&orientation=landscape",
  },
  {
    contentId: "xiangkou-yanhuo",
    tag: "热播剧集",
    image: "https://readdy.ai/api/search-image?query=old%20chinese%20neighborhood%20alley%20at%20dusk%20with%20warm%20window%20lights%20and%20steam%20from%20food%20stalls%2C%20cinematic%20wide%20shot%2C%20warm%20orange%20glow%20with%20blue%20evening%20sky%2C%20cozy%20artistic%20atmosphere&width=1920&height=1000&seq=gydb-hero-05&orientation=landscape",
  },
];

export default featured;